import React from "react";
import { set, useForm } from "react-hook-form";
import { Button, Box, Typography, Grid, Card } from "@mui/material";
import RFG from "../../libs/inputs/RFG";
import ImageEditor from "../../libs/imgcrop/ImageEditor";
import ImageResizer from "../extra/ImageResizer";
import CountryList from 'country-list-with-dial-code-and-flag'
import ReactCountryFlag from "react-country-flag"
import CountrySelect from "../extra/CountrySelect";

export default function Form({
    title,
    packages = [],
    defaultValues = {},
    onSubmit = () => { },
    onCancel = () => { },
}) {
    const { handleSubmit, control, setValue, watch, clearErrors } = useForm({
        defaultValues,
        mode: "all",
    });

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ py: 4 }}>
                {title && (
                    <Typography level="h4" textAlign="center" mb={3}>
                        {title}
                    </Typography>
                )}

                <Grid container spacing={3}>
                    {/* Left Column */}
                    <Grid size={{ xs: 12, md: 4 }} >
                        <RFG
                            name="company_name"
                            label="Company Name"
                            control={control}
                            rules={{
                                required: true, maxLength: {
                                    value: 100,
                                    message: `Cannot exceed 100 characters`,
                                },
                                minLenght: {
                                    value: 3,
                                    message: "Cannot be less than 3 characters",
                                },
                                pattern: {
                                    value: /^[A-Za-z0-9\s&.,'-]+$/,
                                    message: "Invalid company name. Allowed: letters, numbers, spaces, & . , - '",
                                },

                            }}
                        >
                            <input placeholder="e.g. Acme Inc." autoComplete="off" />
                        </RFG>

                        <Box display={'flex'} gap={2}>
                            <Box minWidth={100}>
                                <RFG
                                    name="country_code"
                                    label="Phone Code"
                                    control={control}
                                    rules={{ required: true }}
                                >
                                    <CountrySelect
                                        defaultValue={defaultValues.country_code}
                                        labelKey="dial_code"
                                        valueKey="dial_code"
                                        //onValueChange={(country) => setValue("country_code", country.value)}
                                        onValueChange={(country) => {
                                            // Set and validate the same field name
                                            const value = country?.value || "";
                                            setValue("country_code", value, { shouldValidate: true });
                                            if (value) clearErrors("country_code");
                                            // no setError here; RHF required rule shows the message on submit
                                        }}
                                    />
                                </RFG>
                            </Box>
                            <Box width={1}>
                                <RFG
                                    name="company_phone"
                                    label="Company Phone"
                                    control={control}
                                    rules={{
                                        required: true,
                                        pattern: {
                                            value: /^[0-9]{5,15}$/,
                                            message: "Phone number must be between 5 and 15 digits",
                                        },
                                        maxLength: {
                                            value: 15,
                                            message: `Cannot exceed 15 digits`,
                                        }
                                    }}
                                >
                                    <input placeholder="e.g. 1234567890" autoComplete="off" />
                                </RFG>
                            </Box>
                        </Box>

                        <RFG
                            name="company_email"
                            label="Company Email"
                            control={control}
                            rules={{
                                required: true, maxLength: {
                                    value: 30,
                                    message: `Cannot exceed 30 characters`,
                                },
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                    message: "Enter a valid email address",
                                }
                            }}
                        >
                            <input placeholder="e.g. info@company.com" autoComplete="off" />
                        </RFG>

                        <RFG
                            name="website"
                            label="Company Website"
                            control={control}
                            rules={{
                                required: true,
                                pattern: {
                                    value: /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/i,
                                    message:
                                        "Invalid URL. Use format like https://example.com or https://www.example.com",
                                },
                            }}
                        >
                            <input placeholder="e.g. https://www.company.com" autoComplete="off" />
                        </RFG>

                        <RFG
                            name="package"
                            label="Package"
                            control={control}
                            rules={{ required: true }}
                        >
                            <select>
                                <option value="">Select Package</option>
                                {packages.map((pack) => (
                                    <option key={pack.id} value={pack.id}>
                                        {pack.title}
                                    </option>
                                ))}
                            </select>
                        </RFG>

                        <RFG
                            name="fax"
                            label="Fax"
                            control={control}
                            rules={{
                                required: true,
                                pattern: {
                                    value: /^\+?[0-9\s\-()]{6,20}(?:\s?(?:ext\.?|Ext\.?)\s?\d{1,5})?$/,
                                    message: "Invalid fax number format",
                                },
                                maxLength: {
                                    value: 10,
                                    message: `Cannot exceed 10 digits`,
                                }
                            }}
                        >
                            <input placeholder="e.g. 123 XXXX" autoComplete="off" />
                        </RFG>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }} >

                        <RFG
                            name="address"
                            label="Company Address"
                            control={control}
                            rules={{
                                required: true, maxLength: {
                                    value: 200,
                                    message: `Cannot exceed 200 characters`,
                                },
                                pattern: {
                                    value: /^[A-Za-z0-9\s.,#/-]+$/,
                                    message: "Invalid address format",
                                }
                            }}
                        >
                            <input placeholder="e.g. 123 Main St" autoComplete="off" />
                        </RFG>
                        <Box >
                            <RFG
                                name="country"
                                label="Country"
                                control={control}
                                rules={{ required: true, }}
                            >
                                <CountrySelect

                                    defaultValue={defaultValues.country}
                                    labelKey="name"
                                    valueKey="code"
                                    //onValueChange={(country) => setValue("country", country.value)}
                                    onValueChange={(country) => {
                                        //console.log("asasa",JSON.stringifycountry)
                                        // Set and validate the same field name
                                        const value = country?.value || "";
                                        const cnty_name = country?.label || "";
                                        setValue("country_name", cnty_name);
                                        setValue("country", value, { shouldValidate: true });
                                        if (value) clearErrors("country");
                                        // no setError here; RHF required rule shows the message on submit
                                    }}
                                />
                            </RFG>
                        </Box>

                        <RFG
                            name="city"
                            label="City"
                            control={control}
                            rules={{
                                required: true, maxLength: {
                                    value: 100,
                                    message: `Cannot exceed 100 characters`,
                                },
                                pattern: {
                                    value: /^[A-Za-z0-9\s.'-]+$/,
                                    message: "Invalid city name. Only letters, spaces, . ' - allowed.",
                                }
                            }}
                        >
                            <input placeholder="e.g. 123 Main St" autoComplete="off" />
                        </RFG>

                        <RFG
                            name="keyperson"
                            label="Contact Person Name"
                            control={control}
                            rules={{
                                required: true, maxLength: {
                                    value: 100,
                                    message: `Cannot exceed 100 characters`,
                                },
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Invalid name format",
                                }
                            }}
                        >
                            <input placeholder="e.g. ALEX..." autoComplete="off" />
                        </RFG>

                        <RFG
                            name="keypersonphone"
                            label="Contact Person Phone"
                            control={control}
                            rules={{
                                required: true, maxLength: {
                                    value: 15,
                                    message: `Cannot exceed 15 digits`,
                                },
                                pattern: {
                                    value: /^(?:\+[1-9]\d{1,3})?\d{5,15}$/,
                                    message: "Invalid phone number format",
                                }
                            }}
                        >
                            <input placeholder="e.g. 000000" autoComplete="off" />
                        </RFG>
                        <Box mt={2}>
                            <Typography className="text" fontSize={13} sx={{ mb: 1 }}>Add company profile image </Typography>
                            <ImageResizer defaultValue={defaultValues?.image} onChange={(bs64) => setValue("image", bs64)} />
                        </Box>
                        {/* </Card> */}
                    </Grid>

                    {/* Right Column */}
                    <Grid size={{ xs: 12, md: 4 }} >
                        <RFG
                            name="first_name"
                            label="First Name"
                            control={control}
                            rules={{
                                required: true, maxLength: 60,
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Invalid name format",
                                }
                            }}
                        >
                            <input type="text" placeholder="First name" autoComplete="off" />
                        </RFG>
                        <RFG
                            name="last_name"
                            label="Last Name"
                            control={control}
                            rules={{
                                required: true, maxLength: 60,
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Invalid name format",
                                }
                            }}
                        >
                            <input type="text" placeholder="Last name" autoComplete="off" />
                        </RFG>

                        <Box display={'flex'} gap={2}>
                            <Box minWidth={100}>
                                <RFG
                                    name="user_country_code"
                                    label="Phone Code"
                                    control={control}
                                    rules={{ required: true }}
                                >
                                    <CountrySelect
                                        defaultValue={defaultValues?.user?.country_code}
                                        labelKey="dial_code"
                                        valueKey="dial_code"
                                        //onValueChange={(country) => setValue("user_country_code", country.value)}
                                        onValueChange={(country) => {
                                            // Set and validate the same field name
                                            const value = country?.value || "";
                                            setValue("user_country_code", value, { shouldValidate: true });
                                            if (value) clearErrors("user_country_code");
                                            // no setError here; RHF required rule shows the message on submit
                                        }}
                                    />
                                </RFG>
                            </Box>
                            <Box width={1}>
                                <RFG
                                    name="phone"
                                    label="User Phone"
                                    control={control}
                                    rules={{
                                        required: true, maxLength: {
                                            value: 15,
                                            message: `Cannot exceed 15 digits`,
                                        }, pattern: {
                                            value: /^[0-9]{5,15}$/,
                                            message: "Phone number must be between 5 and 15 digits",
                                        }
                                    }}
                                >
                                    <input placeholder="e.g. 1234567890" autoComplete="off" />
                                </RFG>
                            </Box>
                        </Box>
                        {!defaultValues.id && <><RFG
                            name="username"
                            label="Email as useranme"
                            control={control}
                            rules={{
                                required: true, maxLength: 30,
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                    message: "Enter a valid email username",
                                }
                            }}
                        >
                            <input placeholder="Username" autoComplete="off" />
                        </RFG>
                            <Typography className="text" fontSize={10} sx={{ mb: 1 }}>Send an email to this address to reset your password.</Typography>

                            <RFG
                                name="password"
                                label="Password"
                                control={control}
                                rules={{ required: true, maxLength: 20 }}
                            >
                                <input type="password" placeholder="Password" autoComplete="off" />
                            </RFG>
                        </>}

                        {/* <Box mt={2}>
                            <Typography fontSize={12} sx={{ mb: 1 }}>Add User profile image</Typography>
                            <ImageResizer defaultValue={defaultValues?.avatar} onChange={(bs64) => setValue("avatar", bs64)} />
                        </Box> */}
                    </Grid>
                </Grid>

                <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
                    <Box flexGrow={1} />
                    <Button variant="danger" className="btn-primary btn-normal" onClick={onCancel}>
                        Back
                    </Button>
                    <Button type="submit" className="btn-primary" style={{ maxWidth: 100 }}>
                        Save
                    </Button>
                </Box>
            </Box>
        </form>
    );
}
